import { Gauge } from "@phosphor-icons/react";
import { UpgradeBanner } from "@/components/UpgradePro";

function getBarColor(pct) {
  if (pct >= 90) return "bg-red-500";
  if (pct >= 60) return "bg-yellow-500";
  return "bg-green-500";
}

export const UsageBar = ({ usage, onUpgradeClick }) => {
  if (!usage) return null;

  const items = Object.entries(usage).filter(([, v]) => v.limit !== null);
  if (items.length === 0) return null;

  return (
    <div className="border-t border-border p-4 bg-surface" data-testid="usage-bar">
      <div className="flex items-center gap-2 mb-3">
        <Gauge size={16} className="text-neutral-400" />
        <span className="text-xs font-semibold uppercase tracking-wider text-neutral-400">Daily Usage</span>
      </div>
      <div className="grid grid-cols-3 gap-2">
        {items.map(([action, val]) => {
          const pct = val.limit > 0 ? Math.round((val.used / val.limit) * 100) : 0;
          return (
            <div key={action} className="text-xs" data-testid={`usage-item-${action}`}>
              <div className="flex justify-between text-neutral-400 mb-1">
                <span>{action.replace(/_/g, " ")}</span>
                <span>{val.used}/{val.limit}</span>
              </div>
              <div className="h-1 bg-neutral-800 overflow-hidden">
                <div
                  className={`h-full transition-all ${getBarColor(pct)}`}
                  style={{ width: `${Math.min(pct, 100)}%` }}
                />
              </div>
            </div>
          );
        })}
      </div>
      {onUpgradeClick && <UpgradeBanner onUpgradeClick={onUpgradeClick} />}
    </div>
  );
};
